import { CheckCircleTwoTone, CloseCircleTwoTone } from '@ant-design/icons';
import { Button, Checkbox, Input, Space, Table, Tooltip, Typography, Alert } from "antd";
import { useState } from "react";
import Cookies from "js-cookie";

export default function ListShareAccountsTab(props) {
    const {
        list = {},
        close = () => { },
        loading = false,
        shareableStores = [],
        setShareableStores = () => { },
        getStartingValues = () => { },
        setShared = () => { },
        setSelectedRowKeys = () => { },
        drawReturnToReportCardButton = () => { },
    } = props;

    const [initShareableStores, setInitShareableStores] = useState([]);
    const [shareCount, setShareCount] = useState(shareableStores.filter(item => item.is_shared).length);
    const { shared_status = "none" } = list;
    const is_public = (shared_status === "everyone");

    function toggleMultiSelect(id, checked) {
        let _sharableStores = [...shareableStores];
        let _f = _sharableStores.findIndex(item => item.contact_id === id);
        if (_f > -1) {
            // found
            _sharableStores[_f].is_shared = checked;
            setShareableStores(_sharableStores);
            setShareCount((checked) ? shareCount + 1 : shareCount - 1);
            setSelectedRowKeys(_sharableStores);
        }
    }

    const columns = [
        {
            title: <small><nobr>Catalogue Shared</nobr></small>, dataIndex: 'is_shared', key: 'is_shared', align: 'left', width: "60px", render: (e, f) => {
                if (is_public) {
                    return (<div style={{ "textAlign": "left" }}> <Tooltip title={<small>Catalogue is public</small>}><Checkbox disabled checked /></Tooltip> </div>)
                } else {
                    return (
                        <div style={{ "textAlign": "left" }}> <Tooltip title={(f.is_read && <small>{f.name} has read this catalogue and it can no longer be unshared with them.</small>)}>
                            <Checkbox disabled={f.is_read || !f.is_client} checked={f.is_shared} defaultChecked={f.is_shared} onClick={(e) => toggleMultiSelect(f.contact_id, e.target.checked)} />
                        </Tooltip></div>
                    )
                }
            }
        },
        {
            title: <small><nobr>My Account</nobr></small>, width: '60px', dataIndex: 'is_client', key: 'is_client', align: 'center', render: (e, f) => {
                if (f.is_client) {
                    return (
                        <CheckCircleTwoTone twoToneColor="green" />
                    )
                } 
            }
        },
      
        {
            title: <small><nobr>Sharing Data</nobr></small>, width: '60px', dataIndex: 'is_sharing', key: 'is_sharing', align: 'center', render: (e, f) => {
                if (e) {
                    return (
                        <CheckCircleTwoTone twoToneColor="green" />
                    )
                }

            }
        },
        {
            title: <small>SAN</small>, width: '80px', align: 'center', dataIndex: 'san', key: 'san', sorter: (a, b) => a.san.localeCompare(b.san),
        },
        {
            title: <small><nobr>Store Name</nobr></small>, dataIndex: 'name', key: 'name', sorter: (a, b) => a.name.localeCompare(b.name),
        },
        {
            title: <small>City</small>, width: '130px', dataIndex: 'city', key: 'city', sorter: (a, b) => a.city.localeCompare(b.city),
        },
        {
            title: <small><nobr>Province/State</nobr></small>, width: '40px', dataIndex: 'province', key: 'province', sorter: (a, b) => a.province.localeCompare(b.province),
        },
    ];

    const resetSelection = () => {

        // Kellynda want's to just uncheck all instead /issues/4806
        setShareableStores(shareableStores.map(item => ({
            ...item,
            is_shared: false
        })));
        // getStartingValues();
        // setSelectedRowKeys([]);
    }

    function shareWithAllAccounts() {
        let temp_client_ids_array = shareableStores.filter((store) => store.is_client);
        setSelectedRowKeys(temp_client_ids_array.map(store => store.contact_id))
        let selected_stores = shareableStores.map((store) => {
            if (temp_client_ids_array.some((item) => item.contact_id === store.contact_id)) {
                // found
                store.is_shared = true;
            }
            return store;
        })
        setShareableStores(selected_stores);
        setShareCount(temp_client_ids_array.length);
        setSelectedRowKeys(selected_stores);
    }

    const searchLocal = (_search, temp_init_stores) => {
        let new_table_data = temp_init_stores.map(item => {
            return { ...item }
        });
        setShareableStores(new_table_data.filter(item => item.name.toUpperCase().includes(_search.toUpperCase())));
    }

    const onChange = (_search) => {
        // ensure init is set
        let temp_init_stores = initShareableStores;
        if (shareableStores.length > initShareableStores.length) {
            temp_init_stores = shareableStores.map(item => {
                return { ...item }
            });
            setInitShareableStores(temp_init_stores);
        }
        if (!_search) {
            setShareableStores(temp_init_stores);
        }
        return searchLocal(_search, temp_init_stores);
    }

    return (
        <div style={{ "padding": "20px" }}>

            <Typography.Title level={5}>Share with your Accounts</Typography.Title>
            <Space>
                <Input onChange={(e) => onChange(e.target.value)} allowClear style={{ "fontSize": "12px" }} size="small" placeholder="Refine by name" />
            </Space>
            <span>
                <Button style={{ "marginLeft": "10px" }} type="primary" onClick={() => shareWithAllAccounts()}>
                    Select all my accounts
                </Button>
                <Button style={{ "marginLeft": "10px" }} type="danger" onClick={() => resetSelection()}>
                    Reset Choices
                </Button>
            </span>
            <div className="shim"></div>

            <Table
                rowKey="san"
                size="small"
                loading={loading}
                pagination={{
                    defaultPageSize: (Cookies.get('page_size')) || 50,
                    onChange: (page, pageSize) => {
                        Cookies.set('page_size', pageSize)
                    }
                }}
                columns={columns}
                dataSource={shareableStores}
            />
            <Alert style={{ "padding": "3px 10px" }} type="warning" description={<small>  Sharing with select accounts means that <strong>only the chosen stores</strong> will have access to this list. If one of your accounts is not listed here, they will <strong>not</strong> be able to view it. To make this list visible to <strong>all booksellers</strong> (including those who are not Bookmanager users), please select the <strong>"Share Publicly"</strong> tab.</small>} />
            <br />
            <span>
                <div style={{ "float": "left" }}>
                    <Space>
                        {drawReturnToReportCardButton()}
                        <Button type="danger" onClick={() => close()}>Cancel</Button>
                    </Space>
                </div>
                <div style={{ "float": "right" }}>
                    <Space size={20}>
                        <div className='c'>Sharing with {shareCount} store{(shareCount !== 1 && "s")}.</div>
                        <Button
                            onClick={(e) => setShared(false, false, shareableStores.filter(item => item.is_shared).map(item => item.contact_id))}
                            type="primary">Save</Button>
                    </Space>
                </div>
            </span>
            <br clear="all" />
        </div>
    )
}